<template>
  <d2-container>
    <template slot="header">
      <el-input v-model="query.id" clearable size="small" placeholder="订单ID" style="width: 160px; margin-right: 8px"></el-input>
      <el-input v-model="query.payerAccountId" clearable size="small" placeholder="付款账户ID" style="width: 160px; margin-right: 8px"></el-input>
      <el-select v-model="query.ownerType" clearable size="small" placeholder="归属类型" style="width: 140px; margin-right: 8px">
        <el-option label="个人" value="PERSONAL"></el-option>
        <el-option label="组织" value="ORGANIZATION"></el-option>
      </el-select>
      <el-input v-model="query.ownerId" clearable size="small" placeholder="归属ID" style="width: 150px; margin-right: 8px"></el-input>
      <el-select v-model="query.payStatus" clearable size="small" placeholder="支付状态" style="width: 120px; margin-right: 8px">
        <el-option label="未支付" :value="0"></el-option>
        <el-option label="已支付" :value="1"></el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="load">搜索</el-button>
    </template>

    <el-table size="small" stripe border :data="records" v-loading="loading">
      <el-table-column prop="id" label="订单ID" width="150"></el-table-column>
      <el-table-column prop="payerAccountId" label="付款账户" width="140"></el-table-column>
      <el-table-column label="归属类型" width="120">
        <template slot-scope="scope">{{ ownerTypeLabel(scope.row.ownerType) }}</template>
      </el-table-column>
      <el-table-column prop="ownerId" label="归属ID" width="150"></el-table-column>
      <el-table-column prop="planName" label="套餐" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="收费模式" width="170">
        <template slot-scope="scope">{{ billingModeLabel(scope.row.billingMode) }}</template>
      </el-table-column>
      <el-table-column prop="seatCount" label="席位" width="90" align="center"></el-table-column>
      <el-table-column prop="payPrice" label="支付金额" width="120" align="right"></el-table-column>
      <el-table-column label="支付状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.payStatus === 1 ? 'success' : 'info'">{{ scope.row.payStatus === 1 ? '已支付' : '未支付' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="subscriptionId" label="订阅ID" width="150"></el-table-column>
      <el-table-column prop="payTime" label="支付时间" width="170"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSize"
        @current-change="handlePage"
      ></el-pagination>
    </template>
  </d2-container>
</template>

<script>
import { getSubscriptionOrders } from '@/api/ai/rights'
import { billingModeLabel, ownerTypeLabel } from './labels'

export default {
  name: 'aiSubscriptionOrderManager',
  data () {
    return {
      query: { currentPage: 1, pageSize: 20, id: '', payerAccountId: '', ownerType: '', ownerId: '', payStatus: '' },
      records: [],
      total: 0,
      loading: false
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      getSubscriptionOrders(this.query).then(res => {
        this.records = (res && res.records) || []
        this.total = Number((res && res.total) || 0)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSize (size) {
      this.query.pageSize = size
      this.load()
    },
    handlePage (page) {
      this.query.currentPage = page
      this.load()
    },
    billingModeLabel,
    ownerTypeLabel
  }
}
</script>
